export default __webpack_public_path__ + "static/media/nalikes.576e8237.svg";